import React, { Component } from "react";
import { Route } from "react-router-dom";
import * as firebase from "firebase";

import Login from "./cenas/Login";
import Feed from "./cenas/Feed";
import AddCity from "./cenas/addCity";
import AddCategory from "./cenas/addCategory";

import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducers from "./redux/reducers";

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faSignOutAlt, faSlidersH, faHeart, faAddressCard, faUser } from '@fortawesome/free-solid-svg-icons';

// library.add(faSlidersH, faSignOutAlt, faHeart, faAddressCard, faUser);

class App extends Component {
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
      authDomain: "tourbrazil-41fbe.firebaseapp.com",
      databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
      projectId: "tourbrazil-41fbe",
      storageBucket: "tourbrazil-41fbe.appspot.com",
      messagingSenderId: "927605208400"
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
  }
  render() {
    return (
      <Provider store={createStore(reducers, {}, applyMiddleware(thunk))}>
        <div>
          <Route exact={true} path={"/"} component={Login} />
          <Route exact={true} path={"/home"} component={Feed} />
          <Route exact={true} path={"/addCity"} component={AddCity} />
          <Route exact={true} path={"/addCategory"} component={AddCategory} />
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js